<template>
  <section class="pdf-content" style="padding: 20px; margin-top: 0">
    <section class="text-center" style="margin-bottom: 20px">
      <p class="h2 font-weight-bold">CREDIT REPORT</p>
      <p class="h2 font-weight-black" style="font-weight: bold">
        {{ dataDetail !== null ? dataDetail.matchedSubData.NameAsId : "" }}
      </p>
    </section>
    <section style="margin-bottom: 20px">
      <span style="margin-right: 5px">
        Request Date:
        {{ dataDetail != null ? dataDetail.matchedSubData.LastUpdateDate : "" }}
      </span>
      <span style="padding: 5px 10px; background: green; color: white">
        {{
          dataDetail !== null
            ? dataDetail.matchedSubData.FlagMatched == "0"
              ? "Subject No Matched"
              : "Subject Matched"
            : ""
        }}
      </span>
    </section>

    <section class="subject">
      <div class="title-text">
        <p class="h3 text-center">SUBJECT</p>
      </div>
      <v-card-text>
        Reference Number :
        {{ dataDetail !== null ? dataDetail.messageRes : "-" }}
      </v-card-text>
      <div class="content-data">
        <v-card class="mb-3">
          <v-card-subtitle class="mb-3 text-h6"> Subject Data </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="3">
                <v-card-subtitle> CB Subject Code </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.CBSubjectCode
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Provider Subject Code </v-card-subtitle>
                <v-card-text>
                  <!-- {{ dataDetail.provider_application_no }} -->
                  -
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Last Update Date </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.LastUpdateDate
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Resident </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.ResidentDesc
                      : ""
                  }}
                </v-card-text>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Name As Id </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.NameAsId
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Full Name </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.FullName
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Mother's Name </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.MothersName
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Gender </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.GenderDesc
                      : ""
                  }}
                </v-card-text>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Date Of Birth </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.BirthDate
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Birth Place </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.BirthPlace
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Marital Status </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.MarriageStatusDesc
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Education Status </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.EducationalStatusCodeDesc
                      : ""
                  }}
                </v-card-text>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-6">
          <v-card-subtitle class="mb-3 text-h6">
            Addresses Data
          </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="8">
                <v-card-subtitle> Current - Address </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.AddressHistory[0].Address
                      : ""
                  }},
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.AddressHistory[0].SubDistrict
                      : ""
                  }},
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.AddressHistory[0].District
                      : ""
                  }},
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.AddressHistory[0].CityDesc
                      : ""
                  }},
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.AddressHistory[0].PostalCode
                      : ""
                  }},
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.AddressHistory[0].CountryDesc
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="4">
                <v-card-subtitle> Last Update Date </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.AddressHistory[0]
                          .lastUpdateDate
                      : ""
                  }}
                </v-card-text>
              </v-col>
            </v-row>
            <v-divider
              v-if="
                dataDetail !== null &&
                dataDetail.matchedSubData.AddressHistory.length > 1
              "
              :thickness="3"
            ></v-divider>
            <v-row
              v-for="(item, index) in dataDetail !== null
                ? dataDetail.matchedSubData.AddressHistory
                : []"
              :key="index"
              :class="{ 'd-none': index == 0 }"
            >
              <v-col cols="12" sm="8">
                <v-card-subtitle v-if="index !== 0">
                  Historical - Address
                </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{ item.Address }}, {{ item.SubDistrict }},
                    {{ item.District }}, {{ item.CityDesc }},
                    {{ item.PostalCode }}, {{ item.CountryDesc }}
                  </template>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="4">
                <v-card-subtitle v-if="index !== 0">
                  Last Update Date
                </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{ item.lastUpdateDate }}
                  </template>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-6">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6">
                <v-card-subtitle class="mb-3 text-h6">
                  Identification Code
                </v-card-subtitle>
                <v-divider :thickness="3" class="blue"></v-divider>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-card-subtitle> Identity Type </v-card-subtitle>
                      <v-card-text>
                        {{
                          dataDetail !== null
                            ? dataDetail.matchedSubData.IdentityTypeDesc
                            : ""
                        }}
                      </v-card-text>
                    </v-col>
                    <v-col>
                      <v-card-subtitle> Identity Number </v-card-subtitle>
                      <v-card-text>
                        {{
                          dataDetail !== null
                            ? dataDetail.matchedSubData.IdentityNumber
                            : ""
                        }}
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>

              <v-col cols="12" sm="6">
                <v-card-subtitle class="mb-3 text-h6"> ID </v-card-subtitle>
                <v-divider :thickness="3" class="blue"></v-divider>
                <v-card-text>
                  <v-card-subtitle> Tax ID </v-card-subtitle>
                  <v-card-text>
                    {{
                      dataDetail !== null ? dataDetail.matchedSubData.NPWP : ""
                    }}
                  </v-card-text>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-6">
          <v-card-subtitle class="mb-3 text-h6"> Contacts </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <v-card-text>
            <v-card-subtitle> Current - Contact </v-card-subtitle>
            <v-row>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Phone Number </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.ContactHistory[0].PhoneNumber
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Cell Phone Number </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.ContactHistory[0]
                          .CellphoneNumber
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Email Address </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.ContactHistory[0].EmailAddress
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Last Update Date </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.ContactHistory[0]
                          .lastUpdateDate
                      : ""
                  }}
                </v-card-text>
              </v-col>
            </v-row>
            <v-divider
              :thickness="3"
              v-if="
                dataDetail !== null &&
                dataDetail.matchedSubData.ContactHistory.length > 1
              "
            ></v-divider>
            <v-card-subtitle
              class="mt-3"
              v-if="
                dataDetail !== null &&
                dataDetail.matchedSubData.ContactHistory.length > 1
              "
            >
              Historical - Contact
            </v-card-subtitle>
            <v-row
              v-for="(item, index) in dataDetail !== null
                ? dataDetail.matchedSubData.ContactHistory
                : []"
              :key="index"
              :class="{ 'd-none': index == 0 }"
            >
              <v-col cols="12" sm="3">
                <v-card-subtitle> Phone Number </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{ item.PhoneNumber }}
                  </template>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Cell Phone Number </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{ item.CellphoneNumber }}
                  </template>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Email Address </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{ item.EmailAddress }}
                  </template>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Last Update Date </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{ item.lastUpdateDate }}
                  </template>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-6">
          <v-card-subtitle class="mb-3 text-h6">
            Employment Data
          </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <v-card-text>
            <v-card-subtitle> Current - Employment Data </v-card-subtitle>
            <v-row>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Occupation </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.EmploymentDataHistory.length >
                        0
                        ? dataDetail.matchedSubData.EmploymentDataHistory[0]
                            .OccupationDesc
                        : "-"
                      : "-"
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Work Place </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.EmploymentDataHistory.length >
                        0
                        ? dataDetail.matchedSubData.EmploymentDataHistory[0]
                            .Workplace
                        : "-"
                      : "-"
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Employer Sector </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.EmploymentDataHistory.length >
                        0
                        ? dataDetail.matchedSubData.EmploymentDataHistory[0]
                            .EmployerSectorDesc
                        : "-"
                      : "-"
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Work Place Address </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.EmploymentDataHistory.length >
                        0
                        ? dataDetail.matchedSubData.EmploymentDataHistory[0]
                            .WorkplaceAddress
                        : "-"
                      : "-"
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Last Update Date </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.matchedSubData.EmploymentDataHistory.length >
                        0
                        ? dataDetail.matchedSubData.EmploymentDataHistory[0]
                            .lastUpdateDate
                        : "-"
                      : "-"
                  }}
                </v-card-text>
              </v-col>
            </v-row>
            <v-divider
              :thickness="3"
              v-if="
                dataDetail !== null &&
                dataDetail.matchedSubData.EmploymentDataHistory.length > 1
              "
            ></v-divider>
            <v-card-subtitle
              class="mt-3"
              v-if="
                dataDetail !== null &&
                dataDetail.matchedSubData.EmploymentDataHistory.length > 1
              "
            >
              Historical - Employment Data
            </v-card-subtitle>
            <v-row
              v-for="(item, index) in dataDetail !== null
                ? dataDetail.matchedSubData.EmploymentDataHistory
                : []"
              :key="index"
              :class="{ 'd-none': index == 0 }"
            >
              <v-col cols="12" sm="3">
                <v-card-subtitle> Occupation </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{ item.OccupationDesc ? item.OccupationDesc : "-" }}
                  </template>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Work Place </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{ item.Workplace ? item.Workplace : "-" }}
                  </template>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Employer Sector </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{
                      item.EmployerSectorDesc ? item.EmployerSectorDesc : "-"
                    }}
                  </template>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Work Place Address </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{ item.WorkplaceAddress ? item.WorkplaceAddress : "-" }}
                  </template>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Last Update Date </v-card-subtitle>
                <v-card-text>
                  <template v-if="index !== 0">
                    {{ item.lastUpdateDate ? item.lastUpdateDate : "-" }}
                  </template>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </section>

    <section class="application-summary-details">
      <div class="title-text">
        <p class="h3 text-center">APPLICATION SUMMARY DETAILS</p>
      </div>
      <div class="content-data">
        <v-card class="mb-6">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="3">
                <v-card-subtitle> CB Contact Code </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.appCodeData.CBContractCode
                      : "-"
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Contract Type </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.appCodeData.ContractTypeDesc
                      : "-"
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Contract Phase </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.appCodeData.ContractPhaseDesc
                      : "-"
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Request Date </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.appCodeData.ContractRequestDate
                      : "-"
                  }}
                </v-card-text>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Application Amount </v-card-subtitle>
                <v-card-text>
                  IDR
                  {{
                    dataDetail !== null
                      ? toRupiah(dataDetail.appCodeData.ApplicationAmount)
                      : "-"
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Due Date </v-card-subtitle>
                <v-card-text>
                  <!-- {{ dataDetail !== null ? dataDetail.appCodeData.DueDate : '-' }} -->
                  -
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Role </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null ? dataDetail.appCodeData.RoleDesc : "-"
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Company Role </v-card-subtitle>
                <v-card-text>
                  <!-- {{ dataDetail !== null ? dataDetail.appCodeData.CompanyRole : '-' }} -->
                  -
                </v-card-text>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Account Number </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.appCodeData.ProviderApplicationNo
                      : "-"
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Original Agreement Number </v-card-subtitle>
                <v-card-text>
                  <!-- {{ dataDetail !== null ? dataDetail.appCodeData.OriginalAgreementNumber : '-' }} -->
                  -
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Original Agreement Date </v-card-subtitle>
                <v-card-text>
                  <!-- {{ dataDetail !== null ? dataDetail.appCodeData.OriginalAgreementDate : '-' }} -->
                  -
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Currency </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.appCodeData.CurrencyDesc
                      : "-"
                  }}
                </v-card-text>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </section>

    <section class="score-detail">
      <div class="title-text">
        <p class="h3 text-center">SCORE DETAIL</p>
      </div>
      <div class="content-dar">
        <v-card class="mb-6">
          <v-card-text v-if="dataDetail.scoreDataData.ScoreData.Code !== ''">
            <v-row>
              <v-col>
                <p>Score Raw</p>
                <p>
                  {{
                    dataDetail !== null
                      ? dataDetail.scoreDataData.ScoreData.ScoreRaw
                      : ""
                  }}
                </p>
              </v-col>
              <v-col>
                <p>Score Range</p>
                <p>
                  {{
                    dataDetail !== null
                      ? dataDetail.scoreDataData.ScoreData.ScoreRange
                      : ""
                  }}
                </p>
              </v-col>
              <v-col>
                <p>Description</p>
                <p>
                  {{
                    dataDetail !== null
                      ? dataDetail.scoreDataData.ScoreData.Description
                      : ""
                  }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text
            v-if="
              dataDetail.scoreDataData.ExclusionRule.CodeExclusionRule !== ''
            "
          >
            <v-row>
              <v-col>
                <p>Description</p>
                <p>
                  {{
                    dataDetail !== null
                      ? dataDetail.scoreDataData.ExclusionRule
                          .DescriptionExclusionRule
                      : ""
                  }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </section>

    <section class="contract-summary">
      <div class="title-text">
        <p class="h3 text-center">CONTRACTS SUMMARY</p>
      </div>
      <div class="content-data">
        <v-card class="mb-6">
          <v-card-subtitle class="mb-3 text-h6"> Key Values </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Contracts number </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.contractsHistoryData.ContractsNumber
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Reporting Providers Number </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.contractsHistoryData.ReportingProvidersNumber
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Total Credit Limit </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.contractsHistoryData.Currency
                      : ""
                  }}
                  {{
                    dataDetail !== null
                      ? toRupiah(
                          dataDetail.contractsHistoryData.TotalCreditLimit
                        )
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Total Potential Exposure </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.contractsHistoryData.Currency
                      : ""
                  }}
                  {{
                    dataDetail !== null
                      ? toRupiah(
                          dataDetail.contractsHistoryData.TotalPotentialExposure
                        )
                      : ""
                  }}
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Total Debit Balance </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.contractsHistoryData.Currency
                      : ""
                  }}
                  {{
                    dataDetail !== null
                      ? toRupiah(
                          dataDetail.contractsHistoryData.TotalDebitBalance
                        )
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Total Overdue </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.contractsHistoryData.Currency
                      : ""
                  }}
                  {{
                    dataDetail !== null
                      ? toRupiah(dataDetail.contractsHistoryData.TotalOverdue)
                      : ""
                  }}
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card-subtitle> Currency </v-card-subtitle>
                <v-card-text>
                  {{
                    dataDetail !== null
                      ? dataDetail.contractsHistoryData.CurrencyDesc
                      : ""
                  }}
                </v-card-text>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-6">
          <v-card-subtitle class="mb-3 text-h6">
            Summary by Category and Phase
          </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" style="text-align: left">
                      Contract Category
                    </th>
                    <th class="text-left" style="text-align: left">
                      Requested
                    </th>
                    <th class="text-left" style="text-align: left">Refused</th>
                    <th class="text-left" style="text-align: left">
                      Renounced
                    </th>
                    <th class="text-left" style="text-align: left">Active</th>
                    <th class="text-left" style="text-align: left">Close</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in dataDetail !== null
                      ? dataDetail.contractsHistoryData.ContractCategory
                      : []"
                    :key="index"
                  >
                    <td>{{ item.Name }}</td>
                    <td>{{ item.Requested }}</td>
                    <td>{{ item.Refused }}</td>
                    <td>{{ item.Renounced }}</td>
                    <td>{{ item.Active }}</td>
                    <td>{{ item.Closed }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>

        <v-card class="mb-6">
          <v-card-subtitle class="mb-3 text-h6">
            Financial Summary
          </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <div class="py-5 px-5">
            <v-row>
              <v-col
                v-for="(item, index) in dataDetail !== null
                  ? dataDetail.contractsHistoryData.ContractCategory
                  : []"
                :key="index"
                cols="12"
                md="6"
              >
                <v-row>
                  <v-col>
                    <v-icon
                      v-if="item.Active > 0"
                      medium
                      color="green darken-2"
                    >
                      mdi-check-circle
                    </v-icon>
                    <v-icon
                      v-if="item.Active == 0"
                      medium
                      color="black darken-2"
                    >
                      mdi-close-circle
                    </v-icon>
                  </v-col>
                  <v-col cols="11">
                    <p>{{ item.Name }}</p>
                    <p>Active {{ item.Name }}: {{ item.Active }}</p>
                    <v-divider :thickness="3" class="mb-1"></v-divider>
                    <v-row v-if="item.CreditLimit !== ''">
                      <v-col>
                        <p>Cradit Limit</p>
                      </v-col>
                      <v-col>
                        <p>IDR</p>
                        <p>{{ toRupiah(item.CreditLimit) }}</p>
                      </v-col>
                    </v-row>
                    <v-row v-if="item.DebitBalance !== ''">
                      <v-col>
                        <p>Debit Balance</p>
                      </v-col>
                      <v-col>
                        <p>IDR</p>
                        <p>{{ toRupiah(item.DebitBalance) }}</p>
                      </v-col>
                    </v-row>
                    <v-row v-if="item.Overdue !== ''">
                      <v-col>
                        <p>Overdue</p>
                      </v-col>
                      <v-col>
                        <p>IDR</p>
                        <p>{{ toRupiah(item.Overdue) }}</p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </div>
    </section>

    <section class="contract-details">
      <div class="title-text">
        <p class="h3 text-center">CONTRACTS DETAILS</p>
      </div>
      <div class="content-data">
        <v-card
          class="mb-6"
          v-for="(item, index) in dataDetail !== null
            ? dataDetail.contractsHistoryData.ContractCategory
            : []"
          :key="index"
        >
          <v-card-subtitle class="mb-3 text-h6">
            {{ item.Name }}
          </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <v-card-subtitle>
            {{ item.Name }} Detail (Requested, Renounced, and Refused)
          </v-card-subtitle>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="text-align: left">No</th>
                  <th class="text-left" style="text-align: left">
                    CB Contract Code
                  </th>
                  <th class="text-left" style="text-align: left">
                    Provider Contract Number
                  </th>
                  <th class="text-left" style="text-align: left">
                    Contract type
                  </th>
                  <th class="text-left" style="text-align: left">
                    Contract Phase
                  </th>
                  <th class="text-left" style="text-align: left">Role</th>
                  <th class="text-left" style="text-align: left">
                    Provider Type
                  </th>
                  <th class="text-left" style="text-align: left">Provider</th>
                  <th class="text-left" style="text-align: left">
                    Contract Request Date
                  </th>
                  <th class="text-left" style="text-align: left">
                    last Update Date
                  </th>
                  <th class="text-left" style="text-align: left">
                    Link Subject List
                  </th>
                  <th class="text-left" style="text-align: left">Note</th>
                </tr>
              </thead>
              <tbody v-for="(subItem, index) in item.NotGranted" :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ subItem.CBContractCode }}</td>
                  <td>
                    {{
                      subItem.ProviderContractNo
                        ? subItem.ProviderContractNo
                        : "-"
                    }}
                  </td>
                  <td>{{ subItem.ContractTypeDesc }}</td>
                  <td>{{ subItem.ContractPhaseDesc }}</td>
                  <td>{{ subItem.RoleDesc }}</td>
                  <td>{{ subItem.ProviderTypeCodeDesc }}</td>
                  <td>{{ subItem.ProviderCodeDesc }}</td>
                  <td>{{ subItem.ContractRequestDate }}</td>
                  <td>{{ subItem.LastUpdateDate }}</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td colspan="12">
                    <no-granted-display
                      :titleName="item.Name"
                      :subitem="subItem"
                    ></no-granted-display>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-card-subtitle>
            {{ item.Name }} Detail (Active, Closed, Close in Advance)
          </v-card-subtitle>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">No</th>
                  <th class="text-left">CB Contract Code</th>
                  <th class="text-left">Provider Contract Number</th>
                  <th class="text-left">Contract type</th>
                  <th class="text-left">Contract Phase</th>
                  <th class="text-left">Role</th>
                  <th class="text-left">Start Date</th>
                  <th class="text-left">Due Date</th>
                  <th class="text-left">Collaterals Counter</th>
                  <th class="text-left">Total Collateral Value</th>
                  <th class="text-left">Guarantors Counter</th>
                  <th class="text-left">Provider Type</th>
                  <th class="text-left">Provider</th>
                  <th class="text-left">last Update Date</th>
                  <th class="text-left">Link Subject List</th>
                  <th class="text-left">Note</th>
                  <!-- <th colspan="15">COLS</th> -->
                </tr>
              </thead>
              <tbody v-for="(subItem, index) in item.Granted" :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ subItem.CBContractCode }}</td>
                  <td>-</td>
                  <td>{{ subItem.ContractTypeCodeDesc }}</td>
                  <td>{{ subItem.ContractPhaseDesc }}</td>
                  <td>{{ subItem.RoleDesc }}</td>
                  <td>{{ subItem.StartDate }}</td>
                  <td>{{ subItem.DueDate }}</td>
                  <td>{{ subItem.CollateralsCounter }}</td>
                  <td>IDR {{ toRupiah(subItem.TotalCollateralValue) }}</td>
                  <td>{{ subItem.GuarantorsCounter }}</td>
                  <td>{{ subItem.ProviderTypeCodeDesc }}</td>
                  <td>{{ subItem.ProviderCodeDesc }}</td>
                  <td>{{ subItem.ReferenceDate }}</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td colspan="16">
                    <child-table-component
                      :subItem="subItem.listProfile"
                    ></child-table-component>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-card
            v-for="(subItem, index) in item.Granted"
            :key="index"
            class="my-3"
          >
            <v-card-subtitle class="font-weight-bold">
              Detail of {{ item.Name }} {{ index + 1 }}:
              {{ subItem.ContractTypeCodeDesc }} -
              {{ subItem.ContractPhaseDesc }}
            </v-card-subtitle>
            <v-card-text>
              <v-simple-table dense class="grey lighten-2 mb-2">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="text-align: left">
                        Provider Type
                      </th>
                      <th class="text-left" style="text-align: left">
                        Provider
                      </th>
                      <th class="text-left" style="text-align: left">
                        CB Contract Code
                      </th>
                      <th class="text-left" style="text-align: left">
                        Provider Contract No.
                      </th>
                      <th class="text-left" style="text-align: left">Role</th>
                      <th class="text-left" style="text-align: left">
                        Last Update Date
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ subItem.ProviderTypeCodeDesc }}</td>
                      <td>{{ subItem.ProviderCodeDesc }}</td>
                      <td>{{ subItem.CBContractCode }}</td>
                      <td>-</td>
                      <td>{{ subItem.RoleDesc }}</td>
                      <td>{{ subItem.ReferenceDate }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-simple-table dense class="mb-2">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="text-align: left">
                        Start Date
                      </th>
                      <th class="text-left" style="text-align: left">
                        Due Date
                      </th>
                      <th class="text-left" style="text-align: left">
                        Past Due Status
                      </th>
                      <th class="text-left" style="text-align: left">
                        Contract Status
                      </th>
                      <th class="text-left" style="text-align: left">
                        Contract Status Date
                      </th>
                      <!-- <th class="text-left">Information</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ subItem.StartDate }}</td>
                      <td>{{ subItem.DueDate }}</td>
                      <td>{{ subItem.PastDueStausDesc }}</td>
                      <td>{{ subItem.ContractStatusDesc }}</td>
                      <td>{{ subItem.ContractStatusDate }}</td>
                      <!-- <td>
                                {{
                                  subItem.Information
                                    ? subItem.Information
                                    : "-"
                                }}
                              </td> -->
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-card-subtitle> Historical Data </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-simple-table dense class="mb-2">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="text-align: left">
                        Reference Date
                      </th>
                      <th class="text-left" style="text-align: left">
                        Days Past Due
                      </th>
                      <th class="text-left" style="text-align: left">
                        Over Due
                      </th>
                      <th class="text-left" style="text-align: left">
                        Bad Credit Cause
                      </th>
                      <th class="text-left" style="text-align: left">
                        Debit Balance
                      </th>
                      <th class="text-left" style="text-align: left">
                        Current Month Realization
                      </th>
                      <th class="text-left" style="text-align: left">
                        Contract Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(subChildItem, index) in subItem.listProfileArr"
                      :key="index"
                    >
                      <td>
                        {{ subChildItem.ReferenceYear }} -
                        {{ generateMonth(subChildItem.ReferenceMonth) }}
                      </td>
                      <td>
                        {{
                          subChildItem.DaysPastDue
                            ? subChildItem.DaysPastDue
                            : "-"
                        }}
                      </td>
                      <td>
                        {{
                          subChildItem.Overdue
                            ? `IDR ${toRupiah(subChildItem.Overdue)}`
                            : "-"
                        }}
                      </td>
                      <td>
                        {{
                          subChildItem.BadCreditCauseDesc
                            ? subChildItem.BadCreditCauseDesc
                            : "-"
                        }}
                      </td>
                      <td>
                        {{
                          subChildItem.DebitBalance
                            ? `IDR ${toRupiah(subChildItem.DebitBalance)}`
                            : "-"
                        }}
                      </td>
                      <td>
                        {{
                          subChildItem.CurrentMonthRealization
                            ? `IDR
                        ${toRupiah(subChildItem.CurrentMonthRealization)}`
                            : "-"
                        }}
                      </td>
                      <td>
                        {{
                          subChildItem.ContractStatusDesc
                            ? subChildItem.ContractStatusDesc
                            : "-"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-card-subtitle> Granted {{ item.Name }} </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">Caracteristic Credit</p>
                      <p>
                        {{
                          subItem.CodeCharacteristicCreditDesc
                            ? subItem.CodeCharacteristicCreditDesc
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Agrement Credit</p>
                      <p>
                        {{
                          subItem.CodeAgreementCreditDesc
                            ? subItem.CodeAgreementCreditDesc
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Original Agrement Number</p>
                      <p>
                        {{
                          subItem.OriginalAgreementNumber
                            ? subItem.OriginalAgreementNumber
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Original Agrement Date</p>
                      <p>
                        {{
                          subItem.OriginalAgreementDate
                            ? subItem.OriginalAgreementDate
                            : "-"
                        }}
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">Final Agreement Number</p>
                      <p>
                        {{
                          subItem.FinalAgreementNumber
                            ? subItem.FinalAgreementNumber
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Final Agrement Date</p>
                      <p>
                        {{
                          subItem.FinalAgreementDate
                            ? subItem.FinalAgreementDate
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Credit Frequency</p>
                      <p>
                        {{
                          subItem.FrequencyOfCredit
                            ? subItem.FrequencyOfCredit
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Credit Start Date</p>
                      <p>
                        {{ subItem.StartDate ? subItem.StartDate : "-" }}
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">Debtor Category</p>
                      <p>
                        {{
                          subItem.DebtorCategoryCodeDesc
                            ? subItem.DebtorCategoryCodeDesc
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Usage Type</p>
                      <p>
                        {{
                          subItem.UsageTypeCodeDesc
                            ? subItem.UsageTypeCodeDesc
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Usage Orientation</p>
                      <p>
                        {{
                          subItem.UsageOrientationCodeDesc
                            ? subItem.UsageOrientationCodeDesc
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Economic Sector</p>
                      <p>
                        {{
                          subItem.EconomicSectorCodeDesc
                            ? subItem.EconomicSectorCodeDesc
                            : "-"
                        }}
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">City</p>
                      <p>
                        {{ subItem.CityCodeDesc ? subItem.CityCodeDesc : "-" }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Project Value</p>
                      <p>
                        {{
                          subItem.ProjectValue
                            ? `IDR ${toRupiah(subItem.ProjectValue)}`
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Type of Interest Rate</p>
                      <p>
                        {{
                          subItem.TypeOfInterestRateDesc
                            ? subItem.TypeOfInterestRateDesc
                            : "-"
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Interest Rate</p>
                      <p>
                        {{
                          subItem.InterestRate
                            ? `${subItem.InterestRate}%`
                            : "-"
                        }}
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">Financing Program</p>
                      <p>
                        {{
                          subItem.FinancigProgramDesc
                            ? subItem.FinancigProgramDesc
                            : "-"
                        }}
                      </p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card-subtitle>
                {{ item.Name }} Limit/Debit Balance
              </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">Initial Credit Limit</p>
                      <p>IDR {{ toRupiah(subItem.InitialCreditLimit) }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Credit Limit</p>
                      <p>IDR {{ toRupiah(subItem.CreditLimit) }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">
                        Currmet Month Realization
                      </p>
                      <p>
                        {{
                          subItem.CurrentMonthRealization == "0"
                            ? "-"
                            : subItem.CurrentMonthRealization
                        }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Debit Balance</p>
                      <p>IDR {{ toRupiah(subItem.DebitBalance) }}</p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">
                        Value in Original Currency
                      </p>
                      <p>
                        {{
                          subItem.ValueInOriginalCurrency == "0"
                            ? "-"
                            : subItem.ValueInOriginalCurrency
                        }}
                      </p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card-subtitle> Overdue </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">Principle Overdue Amount</p>
                      <p>
                        IDR
                        {{ toRupiah(subItem.PrincipalOverdueAmount) }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Interest Overdue Amount</p>
                      <p>
                        IDR
                        {{ toRupiah(subItem.InterestOverdueAmount) }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Days Past Due</p>
                      <p>{{ subItem.DaysPastDue }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Overdue Payments Number</p>
                      <p>{{ subItem.OverduePaymentsNumber }}</p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">Bad Credit Cause</p>
                      <p>{{ "-" }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Bad Credit Date</p>
                      <p>{{ "-" }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Penalty</p>
                      <p>
                        {{
                          subItem.Penalty !== "0"
                            ? "IDR " + toRupiah(subItem.Penalty)
                            : "-"
                        }}
                      </p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card-subtitle> Restructuring </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">Restructuring Plan</p>
                      <p>{{ "-" }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">
                        Initial Restructuring Date
                      </p>
                      <p>{{ "-" }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Final Restructuring Date</p>
                      <p>{{ "-" }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">
                        Frequency of Restructuring
                      </p>
                      <p>
                        {{
                          subItem.FrequencyOfRestructuring == "0"
                            ? "-"
                            : subItem.FrequencyOfRestructuring
                        }}
                      </p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card-subtitle> {{ item.Name }} Maximum </v-card-subtitle>
              <v-divider :thickness="3" class="blue"></v-divider>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">
                        Max Overdue Payments Amount
                      </p>
                      <p>
                        IDR
                        {{ toRupiah(subItem.MaxOverduePaymentsAmount) }}
                      </p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">
                        Max Overdue Payments Number
                      </p>
                      <p>{{ subItem.MaxOverduePaymentsNumber }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">
                        Max Overdue Payments Number Date
                      </p>
                      <p>{{ subItem.WorstStatusDate }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Max Days Past Due</p>
                      <p>{{ subItem.MaxDaysPastDue }}</p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col md="3">
                      <p class="font-weight-medium">Max Days Past Due Date</p>
                      <p>{{ subItem.WorstStatusDate }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">Worst Status</p>
                      <p>{{ subItem.WorstStatusDesc }}</p>
                    </v-col>
                    <v-col md="3">
                      <p class="font-weight-medium">
                        Max Overdue Payments Number Date
                      </p>
                      <p>{{ subItem.WorstStatusDate }}</p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <div
                v-for="(subChildItem, index) in subItem.GrantedCollaterals"
                :key="index"
              >
                <v-card-subtitle
                  >Detail of Collaterals {{ index + 1 }} :
                  {{ subChildItem.CollateralTypeDesc }}</v-card-subtitle
                >
                <v-divider :thickness="3" class="blue"></v-divider>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col md="3">
                        <p class="font-weight-medium">Provider Type</p>
                        <p>{{ subChildItem.ProviderTypeCodeDesc }}</p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Provider</p>
                        <p>
                          {{ subChildItem.ProviderCodeDesc }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Last Update Date</p>
                        <p>
                          {{ subChildItem.ReferenceDate }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-subtitle>Granted Collateral</v-card-subtitle>
                  <v-divider :thickness="3" class="blue"></v-divider>
                  <v-card-text>
                    <v-row>
                      <v-col md="3">
                        <p class="font-weight-medium">Collateral Number</p>
                        <p>{{ subChildItem.CollateralNumber }}</p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Collateral Status</p>
                        <p>
                          {{ subChildItem.CollateralStatusDesc }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Rating</p>
                        <p>
                          {{
                            subChildItem.CollateralRating
                              ? subChildItem.CollateralRating + "%"
                              : "-"
                          }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Rating Institution</p>
                        <p>
                          {{
                            subChildItem.RatingInstitutionDesc
                              ? subChildItem.RatingInstitutionDesc
                              : "-"
                          }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col md="3">
                        <p class="font-weight-medium">Bind Type</p>
                        <p>{{ subChildItem.BindTypeDesc }}</p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Bind Date</p>
                        <p>
                          {{ subChildItem.BindDate }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Collateral Owner Name</p>
                        <p>
                          {{ subChildItem.CollateralOwnerName }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Proof of Ownership</p>
                        <p>
                          {{ subChildItem.ProofOfOwnership }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col md="3">
                        <p class="font-weight-medium">
                          Common Collateral Status
                        </p>
                        <p>{{ subChildItem.CommonCollateralStatusDesc }}</p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">
                          Common Collateral Percentage
                        </p>
                        <p>
                          {{
                            subChildItem.CommonCollateralPercentage == "0"
                              ? "-"
                              : subChildItem.CommonCollateralPercentage
                          }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">
                          Joint Account Credit Status
                        </p>
                        <p>
                          {{ subChildItem.JointAccountCreditStatusDesc }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Insured</p>
                        <p>
                          {{ subChildItem.InsuredDesc }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col md="3">
                        <p class="font-weight-medium">Information</p>
                        <p>
                          {{
                            subChildItem.Information
                              ? subChildItem.Information
                              : "-"
                          }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-subtitle>Collateral Value</v-card-subtitle>
                  <v-divider :thickness="3" class="blue"></v-divider>
                  <v-card-text>
                    <v-row>
                      <v-col md="3">
                        <p class="font-weight-medium">Collateral Value NJOP</p>
                        <p>
                          {{
                            subChildItem.CollateralValueNJOP
                              ? "IDR " +
                                toRupiah(subChildItem.CollateralValueNJOP)
                              : "-"
                          }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">
                          Collateral Value Reporter
                        </p>
                        <p>
                          {{
                            subChildItem.CollateralValueReporter
                              ? "IDR " +
                                toRupiah(subChildItem.CollateralValueReporter)
                              : "-"
                          }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">
                          Assessment Date Reporter
                        </p>
                        <p>
                          {{ subChildItem.CollateralAssessmentDateReporter }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">
                          Collateral Value Indipendent Assersors
                        </p>
                        <p>
                          {{
                            subChildItem.CollateralValueIndependentAssessors ==
                            "0"
                              ? "-"
                              : subChildItem.CollateralValueIndependentAssessors
                          }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col md="3">
                        <p class="font-weight-medium">
                          Independent Assessors Name
                        </p>
                        <p>
                          {{
                            subChildItem.IndependentAssessorsName
                              ? subChildItem.IndependentAssessorsName
                              : "-"
                          }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">
                          Assessment Date Indipendent Assersors
                        </p>
                        <p>
                          {{
                            subChildItem.CollateralAssessmentDateAssessors
                              ? subChildItem.CollateralAssessmentDateAssessors
                              : "-"
                          }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-subtitle>Collateral Address</v-card-subtitle>
                  <v-divider :thickness="3" class="blue"></v-divider>
                  <v-card-text>
                    <v-row>
                      <v-col md="12">
                        <p class="font-weight-medium">Address</p>
                        <p>
                          {{ subChildItem.Address }},
                          {{ subChildItem.CityDesc }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>

              <div
                v-for="(subChildItem, index) in subItem.GuarantorsData"
                :key="index"
              >
                <v-card-subtitle
                  >Detail of Guarantor {{ index + 1 }} :
                  {{ subChildItem.GuarantorTypeDesc }}</v-card-subtitle
                >
                <v-divider :thickness="3" class="blue"></v-divider>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col md="3">
                        <p class="font-weight-medium">Provider Type</p>
                        <p>{{ subChildItem.ProviderTypeCodeDesc }}</p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Provider</p>
                        <p>
                          {{ subChildItem.ProviderCodeDesc }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Last Update Date</p>
                        <p>
                          {{ subChildItem.ReferenceDate }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-subtitle>Granted Guarantor</v-card-subtitle>
                  <v-divider :thickness="3" class="blue"></v-divider>
                  <v-card-text>
                    <v-row>
                      <v-col md="3">
                        <p class="font-weight-medium">Guarantor Name as ID</p>
                        <p>{{ subChildItem.GuarantorNameAsID }}</p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Guarantor Full Name</p>
                        <p>
                          {{ subChildItem.GuarantorFullName }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Percentage Guaranteed</p>
                        <p>
                          {{
                            subChildItem.PercentageGuaranteed == "0"
                              ? "-"
                              : subChildItem.PercentageGuaranteed + "%"
                          }}
                        </p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Information</p>
                        <p>
                          {{ "-" }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-subtitle>Guarantor Identity</v-card-subtitle>
                  <v-divider :thickness="3" class="blue"></v-divider>
                  <v-card-text>
                    <v-row>
                      <v-col md="3">
                        <p class="font-weight-medium">Identity Type</p>
                        <p>{{ subChildItem.IdentityTypeDesc }}</p>
                      </v-col>
                      <v-col md="3">
                        <p class="font-weight-medium">Identity Number</p>
                        <p>
                          {{ subChildItem.IdentityNumber }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-subtitle>Collateral Address</v-card-subtitle>
                  <v-divider :thickness="3" class="blue"></v-divider>
                  <v-card-text>
                    <v-row>
                      <v-col md="12">
                        <p class="font-weight-medium">Address</p>
                        <p>{{ subChildItem.Address }}</p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </div>
    </section>

    <section class="account-receivable">
      <div class="title-text">
        <p class="h3 text-center">ACCOUNT RECEIVABLE</p>
      </div>
      <div class="content-data">
        <v-card class="mb-6">
          <v-card-subtitle class="mb-3 text-h6">
            General Business Company
          </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <v-card-subtitle> Open Transactions </v-card-subtitle>
          <v-divider :thickness="3"></v-divider>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default v-if="dataDetail !== null">
                <thead>
                  <tr>
                    <th class="text-left">Provider</th>
                    <th class="text-left">TransactionType</th>
                    <th class="text-left">TransactionAmount</th>
                    <th class="text-left">Document Date</th>
                    <th class="text-left">Expiry/Due Date</th>
                    <th class="text-left">Close Date</th>
                    <th class="text-left">Dispute Flag</th>
                    <th class="text-left">Dispute Date</th>
                    <th class="text-left">Last Reference Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in dataDetail.accountReceivablesData
                      .AccountReceivables"
                    :key="index"
                  >
                    <td>
                      {{ item.ProviderCodeDesc ? item.ProviderCodeDesc : "" }}
                    </td>
                    <td>
                      {{
                        item.TransactionTypeDesc ? item.TransactionTypeDesc : ""
                      }}
                    </td>
                    <td>
                      {{
                        item.TransactionAmount
                          ? "IDR " + toRupiah(item.TransactionAmount)
                          : ""
                      }}
                    </td>
                    <td>{{ item.DocumentDate ? item.DocumentDate : "" }}</td>
                    <td>{{ item.ExpiryDate ? item.ExpiryDate : "" }}</td>
                    <td>{{ item.ClosingDate ? item.ClosingDate : "-" }}</td>
                    <td>
                      {{ item.DisputeFlagDesc ? item.DisputeFlagDesc : "" }}
                    </td>
                    <td>{{ item.DisputeDate ? item.DisputeDate : "-" }}</td>
                    <td>{{ item.ReferenceDate ? item.ReferenceDate : "" }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </div>
    </section>

    <section class="addition-information">
      <div class="title-text">
        <p class="h3 text-center">ADDITIONAL INFORMATION</p>
      </div>
      <div class="content-data">
        <v-card class="mb-6">
          <v-card-subtitle class="mb-3 text-h6">
            Debt Mediations
          </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <v-card-text>
            <v-col
              cols="12"
              v-for="(item, index) in dataDetail !== null
                ? dataDetail.subjectAdditionalInfoData.SubjectAdditionalInfo
                : []"
              :key="index"
            >
              <v-simple-table dark>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Additional Information No</th>
                      <th class="text-left">Provider Type</th>
                      <th class="text-left">Provider</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ item.AdditionalInformationNo }}</td>
                      <td>{{ item.ProviderTypeCodeDesc }}</td>
                      <td>{{ item.ProviderCodeDesc }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">No</th>
                      <th class="text-left">Information Type</th>
                      <th class="text-left">Details</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Status Date</th>
                      <th class="text-left">Last Reference Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(subItem, index) in item.AdditionalInfoDetails"
                      :key="index"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ subItem.AdditionalInformationTypeDesc }}</td>
                      <td>{{ subItem.AdditionalInformationValue }}</td>
                      <td>{{ subItem.StatusDesc }}</td>
                      <td>{{ subItem.StatusDate }}</td>
                      <td>{{ subItem.ReferenceDate }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-card-text>
        </v-card>
      </div>
    </section>

    <section class="negative-event">
      <div class="title-text">
        <p class="h3 text-center">NEGATIVE EVENT</p>
      </div>
      <div class="content-data">
        <v-card class="mb-6">
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">No.</th>
                    <th class="text-left">Event</th>
                    <th class="text-left">Event Details</th>
                    <th class="text-left">Event Date</th>
                    <th class="text-left">Event Expiry Date</th>
                    <th class="text-left">Provider Type</th>
                    <th class="text-left">Provider</th>
                    <th class="text-left">Last Reference Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in dataDetail.negativeEventsData"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.EventCodeDesc }}</td>
                    <td>{{ item.EventDetail }}</td>
                    <td>{{ item.EventDate }}</td>
                    <td>{{ item.EventExpiryDate }}</td>
                    <td>{{ item.ProviderTypeCodeDesc }}</td>
                    <td>{{ item.ProviderCodeDesc }}</td>
                    <td>{{ item.ReferenceDate }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </div>
    </section>

    <section class="footprint">
      <div class="title-text">
        <p class="h3 text-center">FOOTPRINT</p>
      </div>
      <div class="content-data">
        <v-card class="mb-6">
          <v-card-subtitle class="mb-3 text-h6">
            Number of Enquiries in the last months
          </v-card-subtitle>
          <v-divider :thickness="3" class="blue"></v-divider>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">1 Month</th>
                    <th class="text-left">3 Months</th>
                    <th class="text-left">6 Months</th>
                    <th class="text-left">12 Months</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{
                        dataDetail !== null
                          ? dataDetail.footPrintsData.Count1Month
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        dataDetail !== null
                          ? dataDetail.footPrintsData.Count3Months
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        dataDetail !== null
                          ? dataDetail.footPrintsData.Count6Months
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        dataDetail !== null
                          ? dataDetail.footPrintsData.Count12Months
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </div>
    </section>
  </section>
</template>
  
<script>
import ChildTableComponent from "./ChildTableComponent.vue";
import NoGrantedDisplay from "./NoGrantedDisplay.vue";
export default {
  name: "PdfContentClick",
  components: {
    ChildTableComponent,
    NoGrantedDisplay,
  },

  props: ["dataDetail"],

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$emit("domRendered");
      }, 1000);
    });
  },

  methods: {
    toRupiah(rupiah) {
      var formattedNumber = parseFloat(rupiah).toLocaleString("en");
      return formattedNumber;
    },

    generateMonth(number) {
      if (number == 1) {
        return "JAN";
      } else if (number == 2) {
        return "FEB";
      } else if (number == 3) {
        return "MAR";
      } else if (number == 4) {
        return "APR";
      } else if (number == 5) {
        return "MEI";
      } else if (number == 6) {
        return "JUN";
      } else if (number == 7) {
        return "JUL";
      } else if (number == 8) {
        return "AUG";
      } else if (number == 9) {
        return "SEP";
      } else if (number == 10) {
        return "OCT";
      } else if (number == 11) {
        return "NOV";
      } else if (number == 12) {
        return "DES";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pdf-content {
  width: 100%;
  background: #fff;

  .title-text {
    background: grey;
    border-radius: 10px;
    margin-bottom: 10px;

    p {
      font-weight: bold;
      color: white;
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }

  .sub-title {
    border-bottom: solid 2px greenyellow;
  }

  .content-data {
    padding: 0px 10px;
  }
}
</style>